/* eslint-disable no-unused-vars */
import React from 'react';

import LanguageIcon from '@mui/icons-material/Language';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useNavigate } from 'react-router';

import { DiscordIcon } from '../Icons/DiscordIcon';

import { StyledNFTCard, useStyles } from './styled';

export const MediaCard = (props) => {
  const {
    description,
    logo_url,
    ecosystems,
    token_name,
    public_mint_price,
    social_handles,
    index,
    token_id
  } = props;
  const { twitter_url, telegram_url, website_url, discord_url } =
    social_handles.length > 0 ? social_handles[0] : {};
  const styles = useStyles();

  const navigate = useNavigate();

  const onCardClick = () => {
    localStorage.setItem('nftTokenId', token_id);
    navigate(`/nftDetails/${token_name}`);
  };

  return (
    <StyledNFTCard sx={{ position: 'relative' }} onClick={onCardClick}>
      <CardMedia
        //component="img"
        image={logo_url}
        sx={{
          m: 1,
          borderRadius: '6px',

          height: 0,
          paddingBottom: '90%'
        }}
      />
      <CardContent sx={{ pb: '2px !important' }}>
        <Stack justifyContent="space-between">
          <Typography variant="title1" textAlign="center">
            {token_name}
          </Typography>
          <Typography variant="title2" textAlign="center">
            {ecosystems?.[0]?.ecosys_name}
          </Typography>

          <Typography
            variant="title2"
            textAlign="center"
            sx={{
              mt: 1,
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3
            }}>
            {description}
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center">
          {twitter_url ? (
            <Tooltip title="Twitter">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                disabled={twitter_url ? false : true}
                href={twitter_url}
                target="_blank">
                <TwitterIcon sx={{ color: twitter_url ? '#3d79e9' : '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
          ) : null}
          {telegram_url ? (
            <Tooltip title="Telegram">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                disabled={telegram_url ? false : true}
                href={telegram_url}
                target="_blank">
                <TelegramIcon sx={{ color: telegram_url ? '#3d79e9' : '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
          ) : null}

          {website_url ? (
            <Tooltip title="Webiste">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                disabled={website_url ? false : true}
                href={website_url}
                target="_blank">
                <LanguageIcon sx={{ color: website_url ? '#3d79e9' : '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
          ) : null}

          {discord_url ? (
            <Tooltip title="Discord">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                disabled={discord_url ? false : true}
                href={discord_url}
                target="_blank">
                <DiscordIcon sx={{ color: discord_url ? '#3d79e9' : '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
          ) : null}
        </Stack>
      </CardContent>
    </StyledNFTCard>
  );
};
